// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"212":"3b95b63c","720":"075b3dd9","887":"75c0e051","993":"f0bca3f0"}[chunkId] + ".css";
};